import { Calendar, Clock, User } from "lucide-react"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"

interface PostMetadataProps {
  date: string
  readTime: string
  author: string
  avatar?: string
}

export function PostMetadata({ date, readTime, author, avatar }: PostMetadataProps) {
  return (
    <div className="mb-8 flex flex-wrap items-center gap-6 text-sm text-muted-foreground">
      <div className="flex items-center gap-2">
        {avatar ? (
          <Avatar className="h-6 w-6">
            <AvatarImage src={avatar || "/placeholder.svg"} alt={author} />
            <AvatarFallback className="text-black">{author.charAt(0)}</AvatarFallback>
          </Avatar>
        ) : (
          <User className="h-4 w-4" />
        )}
        <span>{author}</span>
      </div>
      <div className="flex items-center gap-2">
        <Calendar className="h-4 w-4" />
        <span>{date}</span>
      </div>
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4" />
        <span>{readTime} de leitura</span>
      </div>
    </div>
  )
}
